import React from 'react';
import _ from 'lodash';
import basicRoles from '../../constants/roles';

// Legacy <CAN />; to be remove when Group&Permission is fully adopted and Role is remove
function check<PermissionRules, Role extends keyof PermissionRules, Permission>(
    _rules: PermissionRules,
    role: Role,
    action: Permission,
): boolean {
    // Allow SE team to access everything
    if (role === basicRoles.SE) {
        return true;
    }

    const permissions = _rules[role];
    if (!permissions) {
        // role is not present in the rules
        return false;
    }

    const staticPermissions = (permissions as any).static;

    if (staticPermissions && staticPermissions.includes(action)) {
        return true;
    }

    return false;
}

function Can<PermissionRules, Role extends keyof PermissionRules, Permission>(props: any): any {
    return check(props.rules, props.role, props.perform) ? props.yes() : props.no();
}

export default Can;

type CanPermissionProps = {
    userPermissions: string[];
    permission: string | string[];
    yes: () => React.ReactElement;
    no: () => React.ReactElement;
};
function checkPermissions(userPermissions: string[], permission: string | string[]): boolean {
    return permission && Array.isArray(permission)
        ? _.intersection(userPermissions, permission).length === permission.length
        : userPermissions.includes(permission);
}
export const CanPermission = ({ userPermissions, permission, yes, no }: CanPermissionProps): React.ReactElement => {
    const shouldAllowAllPaths = userPermissions.length === 0; // user that does not have any permission (default / new user) we allow all access;

    if (permission === '*') return yes();

    if (shouldAllowAllPaths) return yes();

    return checkPermissions(userPermissions, permission) ? yes() : no();
};
